// extracted by mini-css-extract-plugin
module.exports = {"button":"InputButton_button__PH_SX","disabled":"InputButton_disabled__XPgja","svg":"InputButton_svg__dSc6X"};